import React, { useState } from 'react';
import { AIAvatarSelector } from '../../components/settings/AIAvatarSelector';
import { useStore } from '../../stores';
import './SettingsPage.css';

export const SettingsPage: React.FC = () => {
  const { user, setUser } = useStore();
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem('darkMode') === 'true';
  });

  const handleDarkModeToggle = (enabled: boolean) => {
    setDarkMode(enabled);
    localStorage.setItem('darkMode', enabled.toString());
    
    // 应用暗色模式
    if (enabled) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };

  const handleAvatarChange = (model: string, avatarUrl: string) => {
    console.log(`${model} avatar changed to:`, avatarUrl);
    
    // 更新全局用户状态
    if (user) {
      const updatedUser = {
        ...user,
        ...(model === 'gemini' 
          ? { ai_avatar_gemini: avatarUrl.replace(/^https?:\/\/[^\/]+\//, '') }
          : { ai_avatar_deepseek: avatarUrl.replace(/^https?:\/\/[^\/]+\//, '') }
        )
      };
      setUser(updatedUser);
      
      // 同步到 localStorage
      localStorage.setItem('auth_user', JSON.stringify(updatedUser));
    }
  };

  return (
    <div className="settings-page">
      <div className="settings-container">
        
        
        {/* 外观设置 */}
        <section className="settings-section">
          <h2>外观设置</h2>
          <div className="setting-item">
            <div className="setting-info">
              <span className="setting-icon">🌙</span>
              <span className="setting-label">深色模式</span>
            </div>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={darkMode}
                onChange={(e) => handleDarkModeToggle(e.target.checked)}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>
        </section>
        
        {/* AI 助手头像设置 */}
        <section className="settings-section">
          <h2>AI 助手头像</h2>
          
          <AIAvatarSelector
            model="gemini"
            title="模型A头像"
            onAvatarChange={(url) => handleAvatarChange('gemini', url)}
          />
          
          <AIAvatarSelector
            model="deepseek"
            title="模型B头像"
            onAvatarChange={(url) => handleAvatarChange('deepseek', url)}
          />
        </section>
      </div>
    </div>
  );
};
